import React from 'react';
import { Box } from '@mui/material';
import ComingSoon from '../../Components/ComingSoon';

const IRSForms: React.FC = () => {
  return (
    <Box>
      <ComingSoon
        title="IRS Forms"
        subtitle="Complete and Print IRS Documentation"
        description="Fill out required IRS forms for your chapter. Complete the forms online and print them for submission."
      />
    </Box>
  );
};

export default IRSForms;
